import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
function ImpressionsConsumer() {
  const {
    posts,
    loading,
    error,
    refetch
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 md:grid-cols-3 md:gap-8">
        {[0, 1, 2].map(i => <div key={i} data-index={i} className="flex flex-col">
            <div className="aspect-[3/2] w-full max-h-[240px] bg-muted/40 animate-pulse" />
            <div className="mt-5 h-3 w-32 bg-muted/40 animate-pulse" />
            <div className="mt-3 h-5 w-full bg-muted/40 animate-pulse" />
            <div className="mt-2 h-5 w-3/4 bg-muted/40 animate-pulse" />
            <div className="mt-4 h-3 w-12 bg-muted/40 animate-pulse" />
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="text-sm text-muted-foreground font-default">
        Δεν ήταν δυνατή η φόρτωση των άρθρων.{" "}
        <button onClick={refetch} className="underline underline-offset-4 text-foreground hover:text-primary transition-colors">
          Επανάληψη
        </button>
      </div>;
  }
  if (posts.length === 0) {
    return <p className="text-muted-foreground italic font-serif">
        Δεν υπάρχουν διαθέσιμα άρθρα αυτή τη στιγμή.
      </p>;
  }
  const formatDate = (dateStr?: string) => {
    if (!dateStr) return "";
    try {
      const d = new Date(dateStr);
      return d.toLocaleDateString("el-GR", {
        month: "long",
        year: "numeric"
      });
    } catch {
      return "";
    }
  };
  return <div className="grid grid-cols-1 gap-16 md:grid-cols-3 md:gap-8">
      {posts.slice(0, 3).map((post, i) => <article data-index={i} key={post.id} className="group flex flex-col">
          <Link to={post.link || "#"} className="block">
            <div className="relative w-full overflow-hidden border-x border-b border-border group-hover:border-primary/60 transition-colors duration-[400ms]">
              <div className="aspect-[3/2] w-full max-h-[240px] overflow-hidden bg-muted/30">
                {post.featuredImage ? <img src={post.featuredImage} alt={post.title} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-[700ms] ease-out group-hover:scale-[1.025]" /> : <div className="h-full w-full bg-muted/30" />}
              </div>
            </div>
          </Link>

          <div className="mt-5">
            <p className="font-serif italic text-muted-foreground" style={{
          fontSize: "clamp(0.8125rem, 0.9vw, 0.9375rem)",
          letterSpacing: "0.005em",
          lineHeight: 1.45
        }}>
              {formatDate(post.date)}
            </p>
          </div>

          <h3 className="mt-3 font-default text-foreground line-clamp-2" style={{
        fontSize: "clamp(1.125rem, 1.4vw, 1.375rem)",
        fontWeight: 400,
        letterSpacing: "-0.01em",
        lineHeight: 1.25
      }}>
            <Link to={post.link || "#"} className="hover:text-primary transition-colors duration-[250ms]">
              {post.title}
            </Link>
          </h3>

          <div className="mt-4">
            <Link to={post.link || "#"} className="inline-block font-default text-foreground text-sm group-hover:text-primary transition-colors duration-[250ms]">
              <span className="relative inline-block pb-1 border-b border-foreground group-hover:border-primary group-hover:border-b-[1.5px] transition-all duration-[250ms]">
                Διαβάστε περισσότερα
              </span>
            </Link>
          </div>
        </article>)}
    </div>;
}
export default function Archive() {
  const wp_query_params = {
    post_type: "post",
    per_page: 3,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="12635" id="posts-grid-archive" className="bg-background text-foreground py-24 md:py-32">
      <div className="mx-auto w-full" style={{
      maxWidth: "1440px",
      paddingLeft: "clamp(1.5rem, 6vw, 7rem)",
      paddingRight: "clamp(1.5rem, 6vw, 7rem)"
    }}>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-12 md:items-end mb-16 md:mb-20">
          <div className="md:col-span-6">
            <h4 className="font-default text-foreground uppercase" style={{
            fontSize: "clamp(0.8125rem, 0.9vw, 0.9375rem)",
            fontWeight: 500,
            letterSpacing: "0.04em",
            lineHeight: 1.3
          }}>
              Από το ημερολόγιό μας
            </h4>
          </div>
          <div className="md:col-span-6 md:col-start-7 md:text-right">
            <Link to="/HomePage" className="group inline-block font-default text-foreground" style={{
            fontSize: "clamp(0.8125rem, 0.9vw, 0.9375rem)"
          }}>
              <span className="relative inline-block pb-1 border-b border-foreground group-hover:border-primary group-hover:border-b-[1.5px] group-hover:text-primary transition-all duration-[250ms]">
                Όλες οι δημοσιεύσεις →
              </span>
            </Link>
          </div>
        </div>

        <PostsProvider wp_query={{
        post_type: "post",
        per_page: 3,
        order: "desc",
        orderby: "date"
      }}>
          <ImpressionsConsumer />
        </PostsProvider>
      </div>
    </section>;
}